<template>
    <div class="footer">
        <div class="footer-top">
            <div>
                <div class="title">
                    <img src="../assets/logo-footer.webp" alt="logo" class="logo" />
                    RONGSHENG ASSET OPERATION <br>
                    (THAILAND) CO., LTD.
                </div>
            </div>
            <div>
                <div class="btns">
                    <div class="btn" v-for="btn in btns" :key="btn.name" @click="handleClick(btn.path)">
                        {{ btn.name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-content">
            <div class="item">
                <img src="../assets/footer-icon1.webp" alt="" class="icon">
                <div class="text">2/131 หมู่บ้าน กฤษดานคร ซอยวาสนา 5/6 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพมหานคร 10170
                </div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon2.webp" alt="" class="icon">
                <div class="text">+66 800247158</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon3.webp" alt="" class="icon">
                <div class="text">th@rongshengasset.com</div>
            </div>
        </div>
        <div class="c">
            © 2026 Hak Cipta milik RONGSHENG ASSET OPERATION (THAILAND) CO., LTD.
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const btns = [
    {
        name: "หน้าแรก",
        path: "/",
    },
    {
        name: "เกี่ยวกับเรา",
        path: "/service",
    },
    {
        name: "บริการ",
        path: "/about",
    },
    {
        name: "ติดต่อเรา",
        path: "/contact",
    },
];
const handleClick = (path) => {
    router.replace(path);
};
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    height: 259px;
    background: #001642;
    padding: 31px 220px 0;
    box-sizing: border-box;

    .footer-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 72px;

        .title {
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 15px;
            color: #D3D3D3;
            line-height: 24px;

            .logo {
                width: 44px;
                height: 44px;
                object-fit: cover;
                margin-right: 7px;
            }
        }

        .btns {
            display: flex;
            justify-content: space-around;
            flex: 1;

            .btn {
                padding: 0 20px;
                box-sizing: border-box;
                font-weight: bold;
                font-size: 14px;
                color: #D3D3D3;
                line-height: 14px;
                text-align: center;
                cursor: pointer;
            }
        }
    }

    .footer-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 31px;

        .item {
            display: flex;
            align-items: center;

            .icon {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 8px;
            }

            .text {
                max-width: 276px;
                font-weight: 500;
                font-size: 12px;
                color: #D3D3D3;
                line-height: 18px;
            }
        }
    }

    .c {
        font-weight: 500;
        font-size: 12px;
        color: #EAEAEA;
        line-height: 24px;
        text-align: center;
    }
}
</style>